module.exports = __webpack_public_path__ + "8e0e1cbcb771690ce1e9320b259e7dec.pdf";